<template>
  <div class="footer-social-media">
    <div class="footer-social-media__label">{{ title }}</div>

    <div class="footer-social-media__buttons">
      <a
        v-if="instagramUrl"
        :href="instagramUrl"
        target="_blank"
        rel="noreferrer"
      >
        <img :src="instagramIcon" alt="Instagram" />
      </a>
      <a v-if="twitterUrl" :href="twitterUrl" target="_blank" rel="noreferrer">
        <img :src="twitterIcon" alt="Twitter" />
      </a>
      <a
        v-if="facebookUrl"
        :href="facebookUrl"
        target="_blank"
        rel="noreferrer"
      >
        <img :src="facebookIcon" alt="Facebook" />
      </a>
      <a
        v-if="pinterestUrl"
        :href="pinterestUrl"
        target="_blank"
        rel="noreferrer"
      >
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterSocialMedia",
  props: {
    title: {
      type: String,
      default: "Follow us on social media",
    },
    instagramUrl: {
      type: String,
    },
    twitterUrl: {
      type: String,
    },
    facebookUrl: {
      type: String,
    },
    pinterestUrl: {
      type: String,
    },
  },
  data() {
    return {
      instagramIcon: require("../../assets/images/social-media/instagram.svg"),
      twitterIcon: require("../../assets/images/social-media/twitter.svg"),
      facebookIcon: require("../../assets/images/social-media/facebook.svg"),
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/color.scss";
@import "../../scss/mixin.scss";
@import "../../scss/typography.scss";

.footer-social-media {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__label {
    color: $aqua-grey-75;
    @include global-interactive-label-small;

    @include lg-down {
      display: none;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/FooterSocialMedia.vue